export default __webpack_public_path__ + "static/media/lake.0b4b33e1.png";